module.exports = {
    razorPayPublicKey: "rzp_test_zKmV77ODFn4C7c	",
}
